export default {
    props: {
        toolbarClick: {
            type: Function,
            kComposite: 'toolbar.click'
        }, 
        toolbarName: {
            type: String,
            kComposite: 'toolbar.name'
        }, 
        toolbarText: {
            type: String,
            kComposite: 'toolbar.text'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-treelist-vue-wrapper/src/KendoTreeList/Toolbar.js